<template>
  <div class="change-phone-container">
    <change-box class="change-box">
      <template v-slot:content>
        <el-form :model="phoneForm"
                 status-icon
                 :rules="phoneRules"
                 ref="phoneFormRef">
          <el-form-item prop="phoneNumber">
            <h3 class="title">
              找回密码
            </h3>
            <el-input placeholder="手机号/邮箱"
                      v-model="phoneForm.phoneNumber"
                      class="new-phone"
                      autocomplete="off"
                      clearable
                      size="small"></el-input>
          </el-form-item>
          <slide-validation class="validation"
                            @verifySuccess="verifySuccess"></slide-validation>
          <el-form-item prop="verifyCode"
                        class="code-wrapper">
            <el-input placeholder="验证码"
                      v-model="phoneForm.verifyCode"
                      clearable
                      size="small"></el-input>
            <div :class="[{'is-disabled': isDisabled},'get-code-btn']"
                 @click="getCode"
                 v-if="!isSentCode">获取验证码</div>
            <div class="regain-code"
                 v-if="isSentCode">重新获取({{ countDown }})</div>
          </el-form-item>
          <div class="changeMailbox" v-if="isPhoneMail == 'mail'">
            <p>我们已向您的注册邮箱</p>
            <p>{{phoneForm.phoneNumber}}</p>
            <p>发送了一封邮件  请您注意</p>
          </div>
          <div class="changeMailbox" v-if="isPhoneMail == 'phone'">
            <p>我们已向您的绑定手机号  {{phoneForm.phoneNumber}}  发送了验证码</p>
            <p>请您注意查看</p>
          </div>
          <div class="confirm-btn"
               @click="submitPhoneForm">确认</div>
        </el-form>
      </template>
    </change-box>
  </div>
</template>

<script>
import changeBox from '@/components/public/changeBox'
import slideValidation from '@/components/public/slideValidation'
export default {
  components: {
    'change-box': changeBox,
    'slide-validation': slideValidation
  },
  data () {
    let validatePhone = (rule, value, callback) => {
      if (value.trim() === '') {
        this.phoneValidatePass = false
        callback(new Error('请输入手机号'));
      } else {
        let reg1 = /^1[3456789]\d{9}$/
          if (!reg1.test(value)) {
            this.phoneValidatePass = false
            callback(new Error('请输入正确的手机号'))
          } else {
            this.phoneValidatePass = true
            callback();
          }
      }
    };
    return {
      phoneForm: {
        phoneNumber: '',
        verifyCode: ''
      },
      phoneRules: {
        phoneNumber: [
          { validator: validatePhone, trigger: ['blur', 'change'] }
        ],
        verifyCode: [
          { pattern: /^[0-9]{6}$/, message: '请输入正确的验证码', trigger: 'blur' },
        ]
      },
      // 手机号验证成功
      phoneValidatePass: false,
      // 滑块验证成功
      slideValidatePass: false,
      isDisabled: true,
      countDown: 60,
      isSentCode: false,
      timer: 0,
      isPhoneMail: ''
    };
  },
  watch: {
    phoneValidatePass () {
      this.isDisabled = !(this.phoneValidatePass && this.slideValidatePass)
    },
    slideValidatePass () {
      this.isDisabled = !(this.phoneValidatePass && this.slideValidatePass)
    },
    countDown (newval) {
      if (newval < 1) {
        clearInterval(this.timer)
        this.isSentCode = false
        this.countDown = 60
      }
    }
  },
  created () {
  },
  methods: {
    verifySuccess () {
      this.slideValidatePass = true
    },
    getCode () {
      if (this.isDisabled) return
      this.$http.post('/api/services/inquiryApp/account/ResetPasswordSmsSender?phoneNumber=' + this.phoneForm.phoneNumber)
      .then(res => {
        if (res.success) {
          this.isSentCode = true
          this.countDown = 60
          this.timer = setInterval(() => {
            this.countDown--
          }, 1000);
        }
      })
      .catch(err => {
        this.$message.error(err.data.error.message)
      })
    },
    submitPhoneForm () {
      if(!this.phoneForm.verifyCode) return this.$message.error('请输入验证码')
      this.$refs.phoneFormRef.validate((valid) => {
        if (valid) {
          this.$http.post(`/api/services/inquiryApp/account/VerifyResetPasswordPhoneCode?phoneNumber=${this.phoneForm.phoneNumber}&verifyCode=${this.phoneForm.verifyCode}`)
            .then(res => {
              this.$router.push({
                path: `/forgetPassword/retrievePassword`,
                query: {
                  id: res.result,
                  phoneNumber: this.phoneForm.phoneNumber
                }
              })
            })
            .catch(err => {
              this.$message.error(err.data.error.message)
            })
        } else {
          return false;
        }
      });
      
    },
  },
};
</script>
<style lang="less" scoped>
.change-phone-container {
  background-color: #f4f4f4;
  height: 100%;
  padding-top: 50px;
  font-family: 'Source Han Sans CN';
}
.change-box {
  margin: 0 auto;
  text-align: center;
  .el-form-item {
    width: 256px;
    margin: 0 auto 20px;
    // margin-bottom: 0;
  }
  .title {
    text-align: center;
    color: #2f343c;
    margin-bottom: 20px;
  }
  .new-phone {
    width: 256px;
  }
  .validation {
    width: 256px;
    margin: 0 auto 20px;
  }
  .code-wrapper {
    width: 256px;
    height: 32px;
    margin: 0 auto;
    /deep/ .el-form-item__content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .get-code-btn {
      height: 32px;
      line-height: 32px;
      font-size: 12px;
      white-space: nowrap;
      padding: 0 5px;
      background-color: #027cff;
      color: #ffffff;
      border-radius: 3px;
      cursor: pointer;
      margin-left: 20px;
      user-select: none;
    }
    .is-disabled {
      background-color: #eeeeee;
      color: #bbbbbb;
      cursor: not-allowed;
    }
    .regain-code {
      height: 32px;
      margin-left: 20px;
      line-height: 32px;
      font-size: 12px;
      background: #cccccc;
      border-radius: 3px;
      white-space: nowrap;
      color: #ffffff;
      user-select: none;
      cursor: not-allowed;
    }
  }
  .changeMailbox {
    margin-top: 10px;
    p {
      text-align: center;
      color: #2F343C;
      padding: 5px 0;
    }
  }
  .confirm-btn {
    width: 256px;
    height: 32px;
    background-color: #027cff;
    color: #ffffff;
    text-align: center;
    line-height: 32px;
    border-radius: 3px;
    margin: 20px auto;
    user-select: none;
    cursor: pointer;
  }
  
}
</style>